import {
	Container,
	FormControl,
	Grid,
	LinearProgress,
	MenuItem as MenuItemMui,
	TextField,
	Tooltip,
	Typography
} from '@mui/material';
import React, {useEffect, useState} from 'react';

import { API_URL } from 'shared/utils/constants';
import axios from 'axios';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import styled from 'styled-components';
import { useAllQuicksightDashboardAccount } from 'shared/apollo';
import { updateAuthorizationHeader, getAuthorizationHeader } from '../../../utils';

const QuickSight = () => {
  const { data: dashboards, isLoadingDashboards } = useAllQuicksightDashboardAccount();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDashboard, setSelectedDashboard] = useState(0);
  const [dashboardInfo, setDashboardInfo] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (dashboards && dashboards.length > 1 && !isLoading && !started) {
      const dasboard = dashboards[1];
      setStarted(true);
      setSelectedDashboard(dasboard.dbId);
      requestDashboard(dasboard.awsId);
      setDashboardInfo(dasboard);
    }
  }, [dashboards]);

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  const finishLoading = async () => {
    await sleep(1000);
    setIsLoading(false);
  };

  const updateDashboard = (url) => {
    const containerDiv = document.getElementById('embeddingContainer');
    embedDashboard({
      url: url,
      container: containerDiv,
      scrolling: 'yes',
      height: '1100px',
      width: '100%',
      locale: 'en-US',
      footerPaddingEnabled: true,
      sheetTabsDisabled: false,
      printEnabled: true,
      loadCallback: finishLoading
    });
  };

  const requestDashboard = async (awsId) => {
    setIsLoading(true);
    const containerDiv = document.getElementById('embeddingContainer');
    containerDiv.innerHTML = '';
    if (!axios.defaults.headers.common['ti-id-token']) {
      updateAuthorizationHeader();
    }
    const token = getAuthorizationHeader();
    const config = {
      headers: { 'ti-id-token': token }
    };
    const response = await axios.post(`${API_URL}/v4/quicksight`, { aws_id: awsId }, config);
    updateDashboard(response.data.url);
  };

  const handleOnChangeSelect = (id) => {
    setSelectedDashboard(id);
    const dashboard = dashboards.filter(board => board.dbId === id)[0];
    requestDashboard(dashboard.awsId);
    setDashboardInfo(dashboard);
  };

	return (
		<Container maxWidth={false}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Grid container direction="row" justify="space-between" alignItems="center">
          <Grid item xs={6}>
            <Tooltip title={ dashboardInfo?.information ?? 'No information available' } style={{cursor: 'pointer'}} arrow>
              <Typography component="subtitle2" variant="subtitle2" noWrap>
                { dashboardInfo?.name }
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item xs={6} style={{textAlign: 'right'}}>
            { dashboards && dashboards.length > 0 && (
              <SelectBox variant="outlined">
                <TextField
                  onChange={(_, { props }) => handleOnChangeSelect(props?.value)}
                  select
                  value={selectedDashboard}
                  disabled={isLoading}
                >
                  { dashboards.map((dashboard) => (<MenuItem key={dashboard.dbId} value={dashboard.dbId}>{dashboard.name}</MenuItem>))}
                </TextField>
              </SelectBox>
            )}
					</Grid>
					<Grid item xs={2} />
        </Grid>
				{ (isLoading || isLoadingDashboards) && (<Grid item xs={12}><LinearProgress variant="query"/></Grid>)}
        <Dashboard id="embeddingContainer"/>
        {!isLoadingDashboards && dashboards.length === 0 && (<EmptyDashboard>There are no dashboards yet</EmptyDashboard>)}
			</Grid>
		</Container>
	);
};

const SelectBox = styled(FormControl)`
  min-width: 200px !important;
}`;
const Dashboard = styled.div`
  width: 100%;
  height: auto;
`;
const EmptyDashboard = styled.div`
  width: 100%;
  margin-top: 100px;
  text-align: center;
`;
const MenuItem = styled (MenuItemMui)`
  font-size: 12px !important;
  max-height: 20px;
`;

export default QuickSight;
